<template>
  <custome-Dialog
    :dialog-visible.sync="dialogVisible"
    :confirm-text="disabledBtn?'上传视频中...':'保存'"
    :title="title"
    width="50%"
    :confirm-disable="disabledBtn"
    @confirm="confirm"
    @close="close"
  >
    <div class="content">
      <el-form
        ref="createForm"
        :model="createForm"
        :rules="creatRules"
        label-width="120px"
      >
        <el-form-item
          label="线上直播视频名称"
          prop="liveVideoName"
        >
          <el-input v-model="createForm.liveVideoName" />
        </el-form-item>
        <el-form-item
          label="视频时长(秒)"
          prop="duration"
        >
          <el-input v-model="createForm.duration" />
        </el-form-item>
        <el-form-item
          label="上传视频"
          prop="liveVideoUrl"
        >
          <div class="video-upload">
            <upload
              :file-list.sync="createForm.liveVideoUrl"
              type="video"
              @isProcess="getProcess"
            />
            <div />
          </div>
        </el-form-item>
      </el-form>
    </div>
  </custome-Dialog>
</template>
<script>
import customeDialog from '@/components/common/dialog.vue';
import axClient from '@/services';
import upload from '@/components/common/upload/upload.vue';

export default {
  name: 'LiveVideo',
  components: { customeDialog, upload },
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    item: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      title: '直播视频编辑',
      cancelText: '取消',
      disabledBtn: false,
      createForm: {
        liveVideoName: null, // 视频名称
        liveVideoUrl: '', // 直播视频地址
        duration: null, // 视频时长
        id: null,
        courseLiveRecordId: null, // 课程id
      },
      creatRules: {
        liveVideoName: [
          { required: true, message: '请输入线上直播视频名称', trigger: 'blur' },
        ],
        duration: [
          { required: true, message: '请输入线上直播时长', trigger: 'blur' },
        ],
        liveVideoUrl: [
          { required: true, message: '请上传视频', trigger: 'blur' },
        ],
      },
    };
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        const {
          courseLiveRecordId,
          duration,
          liveVideoName,
          id,
          liveVideoUrl,
        } = this.item;
        this.createForm = {
          courseLiveRecordId,
          duration,
          liveVideoName,
          id,
          liveVideoUrl,
        };
        this.$nextTick(() => {
          this.$refs.createForm.clearValidate();
        });
      }
    },
  },
  methods: {
    // 关闭弹窗
    close() {
      this.$emit('update:dialogVisible', false);
      this.$emit('close');
    },
    // 上传过程中
    getProcess(value) {
      this.disabledBtn = value;
    },
    confirm() {
      this.$refs.createForm.validate(async (valid) => {
        if (valid) {
          const data = await axClient.live.desertLiveRecordVideoBackend(this.createForm);
          if (!data) return;
          if (this.createForm.id) {
            this.$message.success('修改线上视频成功');
          }
          this.$emit('update:dialogVisible', false);
          this.$emit('confirm');
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.content {
  min-height: 200px;
  .wx-info {
    padding: 0 0 0 0;
    text-align: left;
    .item {
      margin-bottom: 15px;
      span {
        font-size: 12px;
        color: $--base-color-black;
        &:last-child {
          padding-left: 8px;
        }
      }
    }
  }
}

</style>
